<template>
  <section class="style-section">
    <div class="title-guide">路线文件支持格式</div>
    <div class="content-guide">
      程序支持的路线文件采用txt文件格式，可用系统自带记事本进行编写。
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">路线文件制作方法</div>
    <div class="content-guide">
      <li>
        路线文件根据设计文件路线平面参数表，采用线元法参数表达，参数的详细格式如下：
      </li>
      <div>
        第一行参数（4个）：路线起点X坐标，Y坐标，第一条边方位角（这里的方位角为路线坐标系方位角+90度，也就是0度代表水平向右），起点桩号
      </div>
      <div>从第二行开始的每一行参数都代表一个线元——线段类型，线段参数</div>
      <li>线段类型包括：L——直线，S——缓和曲线，R——圆曲线</li>
      <li>线段类型包括：</li>
      <div>直线——长度</div>
      <div>
        缓和曲线——1（左偏为1，右偏为-1），起始点曲率（直线为0，圆曲线为半径），结束点曲率，长度
      </div>
      <div>圆曲线——R，1（左偏为1，右偏为-1），半径，长度</div>
      <div style="font-weight: 600">示例</div>
      <div>0,0,0,1300</div>
      <div>L,190.1669</div>
      <div>S,-1,0,60,55</div>
      <div>R,-1,60,60.992</div>
      <div>S,-1,60,0,55</div>
      <div>L,83.3751</div>
      <div style="font-weight: 600">逐行解释：</div>
      <div>第1行：路线起点X坐标，Y坐标，第一条边方位角0度，起点桩号K1+300</div>
      <div>第2行：直线，长度190.1669m</div>
      <div>
        第3行：缓和曲线，右偏，起点对应直线曲率为0m，终点对应相接圆曲率半径60m，曲线长度55m
      </div>
      <div>
        第4行：圆曲线，右偏，起点曲率为圆半径60m，终点曲率为圆半径60m，曲线长度60.992m
      </div>
      <div>
        第5行：缓和曲线，右偏，起点对应相接圆曲率半径60m，终点对应直线曲率为0m，曲线长度55m
      </div>
      <div>第6行：直线，长度83.3751m</div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">注意事项</div>
    <div class="content-guide">
      <li>缓和曲线接直线端曲率为0，接圆曲线端曲率为圆曲线半径。</li>
      <li>
        起点桩号不一定需要使用实际桩号，可以定义为0，然后将桥梁起点桩号换算到线元对应位置。
      </li>
      <li>
        起点坐标没有特殊要求的时候可以都输入0，第一条边方位角改动仅仅会使模型在Midas
        Civil中平面旋转。
      </li>
      <li>程序不能识别长短链，有长短链位于路线文件涉及段落时，注意换算桥梁起点桩号。</li>
      <li>上面的示例文件保存在程序安装文件夹中，文件名“平面数据示例.txt”。</li>
    </div>
  </section>
  <el-divider></el-divider>
  <div style="height: 120px"></div>
</template>
<script></script>
